import Modal from "../base/Modal";
import {useEffect, useState} from "react";
import {TextAreaInput, TextInput} from "../forms";
import apiUtils from "../../utils/api";

const SentryBackendReportModal = ({eventId, isOpen, handleClose, userName = '', userEmail = ''}) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const [message, setMessage] = useState('');
    const [name, setName] = useState(userName);
    const [email, setEmail] = useState(userEmail);
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        setIsDisabled(!(name?.length && email?.length && re.test(email) && message?.length));
    }, [name, email, message, re]);
    const changeMessage = (e) => {
        const { value } = e.target;
        setMessage(value);
    }

    const changeName = (e) => {
        setName(e.target.value);
    }

    const changeEmail = (e) => {
        setEmail(e.target.value);
    }
    const handleConfirm = async () => {
        const res = await apiUtils.callAPI('/api/report-error', 'POST', { eventId, comments: message, name, email });
        if (res?.success) {
            setMessage('');
            setEmail('');
            setName('');
            handleClose();
        }
    };

    return (
        <Modal isOpen={isOpen}
               handleClose={handleClose}
               handleConfirm={handleConfirm}
               closeText={'Close'}
               title="Server-side error (feedback)"
               disabled={isDisabled}
        >
            <p className="w-full text-left">Name</p>
            <TextInput change={changeName} name={`name`} value={name} label={`Name`}/>
            <p className="w-full text-left">Email</p>
            <TextInput change={changeEmail} name={`email`} value={email} label={`Email`}/>
            <p className="w-full text-left">Message</p>
            <TextAreaInput change={changeMessage} name={`message`} value={message} label={`Message`}/>
        </Modal>
    );
}

export default SentryBackendReportModal;
